import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_NLP_PIPELINES: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the NLP systems.'),
      403: i18n.t('You are not allowed to fetch the NLP systems.'),
      404: i18n.t('The NLP systems you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the NLP systems.'),
      default: i18n.t('An error occurred fetching the NLP systems.')
    }
  },

  FETCH_NLP_PIPELINE: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the NLP system.'),
      403: i18n.t('You are not allowed to fetch the NLP system.'),
      404: i18n.t('The NLP system you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching the NLP system.'),
      default: i18n.t('An error occurred fetching the NLP system.')
    }
  },

  FETCH_NLP_PIPELINE_STATUS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the NLP system status.'),
      403: i18n.t('You are not allowed to fetch the NLP system status.'),
      404: i18n.t('The NLP system status you are trying to fetch does not exist.'),
      500: i18n.t('An error occurred fetching NLP system status.'),
      default: i18n.t('An error occurred fetching the NLP system status.')
    }
  },

  CREATE_NLP_PIPELINE: {
    ERROR: {
      401: i18n.t('You are not authorized to create the NLP system.'),
      403: i18n.t('You are not allowed to create the NLP system.'),
      404: i18n.t('The NLP system you are trying to create does not exist.'),
      500: i18n.t('There was an error creating the NLP system.'),
      default: i18n.t('An error occurred creating the NLP system.')
    },
    SUCCESS: {
      200: i18n.t('NLP system created successfully.'),
      201: i18n.t('NLP system created successfully.')
    }
  },

  UPDATE_NLP_PIPELINE: {
    ERROR: {
      401: i18n.t('You are not authorized to update the NLP system.'),
      403: i18n.t('You are not allowed to update the NLP system.'),
      404: i18n.t('The NLP system you are trying to update does not exist.'),
      500: i18n.t('There was an error updating the NLP system.'),
      default: i18n.t('An error occurred updating the NLP system.')
    },
    SUCCESS: {
      200: i18n.t('NLP system updated successfully.')
    }
  },

  DELETE_NLP_PIPELINE: {
    ERROR: {
      401: i18n.t('You are not authorized to delete the NLP system.'),
      403: i18n.t('You are not allowed to delete the NLP system.'),
      404: i18n.t('The NLP system you are trying to delete does not exist.'),
      500: i18n.t('There was an error deleting the NLP system.'),
      default: i18n.t('An error occurred deleting the NLP system.')
    },
    SUCCESS: {
      200: i18n.t('NLP system deleted successfully.')
    }
  },

  UPDATE_PRIMARY_NLP_PIPELINE: {
    ERROR: {
      401: i18n.t('You are not authorized to update the NLP system.'),
      403: i18n.t('You are not allowed to update the NLP system.'),
      404: i18n.t('The NLP system you are trying to update does not exist.'),
      500: i18n.t('There was an error updating the NLP system.'),
      default: i18n.t('An error occurred updating the NLP system.')
    },
    SUCCESS: {
      200: i18n.t('NLP system updated successfully.')
    }
  },

  TRAIN_NLP_PIPELINE: {
    ERROR: {
      401: i18n.t('You are not authorized to train this system.'),
      403: i18n.t('You are not allowed to train this system.'),
      404: i18n.t('The system you are trying to train does not exist.'),
      500: i18n.t('There was an error starting the NLP training.'),
      default: i18n.t('An error occurred starting the NLP training.')
    },
    SUCCESS: {
      200: i18n.t('System training started.')
    }
  },

  FETCH_HELVIA_PIPELINE_SETTINGS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the pipeline settings.'),
      403: i18n.t('You are not allowed to fetch the pipeline settings.'),
      404: i18n.t('The pipeline settings you are trying to fetch do not exist.'),
      500: i18n.t('An error occurred fetching the pipeline settings.'),
      default: i18n.t('An error occurred fetching the pipeline settings.')
    }
  },

  CREATE_HELVIA_PIPELINE_SETTINGS: {
    ERROR: {
      401: i18n.t('You are not authorized to create the pipeline settings.'),
      403: i18n.t('You are not allowed to create the pipeline settings.'),
      404: i18n.t('The pipeline settings you are trying to create does not exist.'),
      500: i18n.t('There was an error creating the pipeline settings.'),
      default: i18n.t('An error occurred creating the pipeline settings.')
    },
    SUCCESS: {
      200: i18n.t('Pipeline settings created successfully.'),
      201: i18n.t('Pipeline settings created successfully.')
    }
  },

  UPDATE_HELVIA_PIPELINE_SETTINGS: {
    ERROR: {
      401: i18n.t('You are not authorized to update the pipeline settings.'),
      403: i18n.t('You are not allowed to update the pipeline settings.'),
      404: i18n.t('The pipeline settings you are trying to update does not exist.'),
      500: i18n.t('There was an error updating the pipeline settings.'),
      default: i18n.t('An error occurred updating the pipeline settings.')
    },
    SUCCESS: {
      200: i18n.t('Pipeline settings updated successfully.')
    }
  }
};
